import { render, staticRenderFns } from "./User__Clovers.vue?vue&type=template&id=0fb1ff92&lang=pug&"
import script from "./User__Clovers.vue?vue&type=script&lang=js&"
export * from "./User__Clovers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports